export default "__VITE_ASSET__CTWNR5SP__"